import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const LogoPlaceholder = (props) => (_jsxs("svg", { ...props, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", children: [_jsx("path", { d: "M8 11.7143L11 16.2952L15.5 8L22 21H2L8 11.7143Z", fill: "#768093" }), _jsx("circle", { cx: "9", cy: "6", r: "3", fill: "#768093" })] }));
export default LogoPlaceholder;
